// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"96":"vendors","524":"app","687":"mobile_style","922":"bootstyle"}[chunkId] || chunkId) + ".bundle.js";
};